module.exports = __webpack_public_path__ + "img/codeapprove-icon.82e2373e.png";